export const theme = {
  border: "#F1F7ED",
  border100: "#5C5C5C",

  text: "#FFFFFF",
  background100: "#3f3f46",

  green: "#4DBB60",
  red: "#FF0000",
  gray: "#E6E6E6",
} as const;
